import { render, staticRenderFns } from "./franchise-management.vue?vue&type=template&id=6da89f25&scoped=true&"
import script from "./franchise-management.vue?vue&type=script&lang=js&"
export * from "./franchise-management.vue?vue&type=script&lang=js&"
import style0 from "./franchise-management.vue?vue&type=style&index=0&id=6da89f25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da89f25",
  null
  
)

export default component.exports